import { CustomIconCodes } from "../../../components/Icon/custom/CustomIcon";
import type { MenuIconItem, MenuItem, MenuItemGroup, SubMenuItem } from "../types/menuTypes";
import { ResourceName } from "./ResourceName";
import { routes } from "./routes";

/**
 * All menu Items have to contain all the items that will be presented in the menu.
 * */
export const navigation = [
    {
        key: "featured-menu-items",
        title: "",
        unclassifiedItems: [
            {
                titleKey: "menu.dashboard",
                route: routes.dashboard,
                to: routes.dashboard.fillPathParams(),
                menuIcon: CustomIconCodes.Dashboard,
                permission: ResourceName.CONFIGURATION_TRANSFER,
            } as MenuIconItem,
            {
                titleKey: "menu.siteGroups",
                route: routes.siteGroups,
                to: routes.siteGroups.fillPathParams(),
                menuIcon: CustomIconCodes.Endpoint,
                permission: ResourceName.SITE_GROUPS,
            } as MenuIconItem,
            {
                titleKey: "menu.sites",
                route: routes.sites,
                to: routes.sites.fillPathParams(),
                menuIcon: CustomIconCodes.Site,
                permission: ResourceName.SITES,
            } as MenuIconItem,
            {
                titleKey: "menu.organisationUnitsTree",
                route: routes.organisationUnitsTree,
                to: routes.organisationUnitsTree.fillPathParams(),
                menuIcon: CustomIconCodes.Endpoint,
                permission: ResourceName.SITES,
            } as MenuIconItem,
            {
                titleKey: "menu.virtualSiteGroups",
                route: routes.virtualSiteGroups,
                to: routes.virtualSiteGroups.fillPathParams(),
                menuIcon: CustomIconCodes.Endpoint,
                permission: ResourceName.VIRTUAL_SITE_GROUPS,
            } as MenuIconItem,
            {
                titleKey: "menu.contracts",
                route: routes.contracts,
                to: routes.contracts.fillPathParams(),
                menuIcon: CustomIconCodes.Document,
                permission: ResourceName.CONTRACTS,
            } as MenuIconItem,
            {
                titleKey: "menu.terminals",
                route: routes.terminals,
                to: routes.terminals.fillPathParams(),
                menuIcon: CustomIconCodes.Ok,
                permission: ResourceName.TERMINALS,
            } as MenuIconItem,
        ],
    } as MenuItemGroup,
    {
        key: "menu-items",
        title: "",
        subMenus: [
            {
                key: "submenu_logs",
                icon: CustomIconCodes.Card,
                title: "menu.logs",
                menuItems: [
                    // {
                    //     titleKey: "menu.mrnImportLog",
                    //     route: routes.mrnImportLog,
                    //     to: routes.mrnImportLog.fillPathParams(),
                    // } as MenuItem,
                    {
                        titleKey: "menu.terminalImportLog",
                        route: routes.terminalImportLog,
                        to: routes.terminalImportLog.fillPathParams(),
                        permission: ResourceName.TERMINAL_IMPORT_LOG,
                    } as MenuItem,
                    {
                        titleKey: "menu.dealerChangeLog",
                        route: routes.dealerChangeLog,
                        to: routes.dealerChangeLog.fillPathParams(),
                        permission: ResourceName.DEALER_CHANGE_LOGS,
                    } as MenuItem,
                ],
            } as SubMenuItem,
            {
                key: "submenu_profiles",
                icon: CustomIconCodes.Ok,
                title: "menu.profiles",
                menuItems: [
                    {
                        titleKey: "menu.productsProfiles",
                        route: routes.productProfiles,
                        to: routes.productProfiles.fillPathParams(),
                        permission: ResourceName.PRODUCT_PROFILES,
                    } as MenuItem,
                    {
                        titleKey: "menu.products",
                        route: routes.products,
                        to: routes.products.fillPathParams(),
                        permission: ResourceName.PRODUCTS,
                    } as MenuItem,
                    {
                        titleKey: "menu.dialogProfiles",
                        route: routes.dialogProfiles,
                        to: routes.dialogProfiles.fillPathParams(),
                        permission: ResourceName.DIALOG_PROFILES,
                    } as MenuItem,
                    // {
                    //     titleKey: "menu.methodsOfPaymentProfiles",
                    //     route: routes.paymentMethodProfiles,
                    //     to: routes.paymentMethodProfiles.fillPathParams(),
                    // } as MenuItem,
                    // {
                    //     titleKey: "menu.methodsOfPayment",
                    //     route: routes.paymentMethods,
                    //     to: routes.paymentMethods.fillPathParams(),
                    // } as MenuItem,
                    {
                        titleKey: "menu.applicationsProfiles",
                        route: routes.applicationProfiles,
                        to: routes.applicationProfiles.fillPathParams(),
                        permission: ResourceName.APPLICATION_PROFILE_LISTS,
                    } as MenuItem,
                    {
                        titleKey: "menu.cardTypes",
                        route: routes.cardTypes,
                        to: routes.cardTypes.fillPathParams(),
                        permission: ResourceName.CARD_TYPES,
                    } as MenuItem,
                    {
                        titleKey: "menu.contractProfiles",
                        route: routes.contractProfiles,
                        to: routes.contractProfiles.fillPathParams(),
                        permission: ResourceName.CONTRACT_PROFILES,
                    } as MenuItem,
                    {
                        titleKey: "menu.vatCodes",
                        route: routes.vatCodes,
                        to: routes.vatCodes.fillPathParams(),
                        permission: ResourceName.VAT_CODES,
                    } as MenuItem,
                    {
                        titleKey: "menu.promptData",
                        route: routes.promptDataProfiles,
                        to: routes.promptDataProfiles.fillPathParams(),
                        permission: ResourceName.PROMPT_DATA_PROFILES,
                    } as MenuItem,
                ],
            } as SubMenuItem,
            {
                key: "submenu_advancedConfigs",
                icon: CustomIconCodes.Device,
                title: "menu.advancedConfigs",
                menuItems: [
                    {
                        titleKey: "menu.acquirer",
                        route: routes.acquirers,
                        to: routes.acquirers.fillPathParams(),
                        permission: ResourceName.ACQUIRER,
                    } as MenuItem,
                    {
                        titleKey: "menu.globalConfiguration",
                        route: routes.globalConfigurations,
                        to: routes.globalConfigurations.fillPathParams(),
                        permission: ResourceName.GLOBAL_CONFIGURATIONS,
                    } as MenuItem,
                    {
                        titleKey: "menu.hostProductCodes",
                        route: routes.hostProductCodes,
                        to: routes.hostProductCodes.fillPathParams(),
                        permission: ResourceName.HOST_PRODUCT_CODES,
                    } as MenuItem,
                    {
                        titleKey: "menu.hostConfigurations",
                        route: routes.hostConfigurations,
                        to: routes.hostConfigurations.fillPathParams(),
                        permission: ResourceName.HOST_CONFIGURATIONS,
                    } as MenuItem,
                    {
                        titleKey: "menu.terminalProfiles",
                        route: routes.terminalProfiles,
                        to: routes.terminalProfiles.fillPathParams(),
                        permission: ResourceName.TERMINAL_PROFILES,
                    } as MenuItem,
                    {
                        titleKey: "menu.terminalPassword",
                        route: routes.terminalPassword,
                        to: routes.terminalPassword.fillPathParams(),
                        permission: ResourceName.TERMINAL_PASSWORD,
                    } as MenuItem,
                    {
                        titleKey: "menu.cardImplementations",
                        route: routes.cardImplementations,
                        to: routes.cardImplementations.fillPathParams(),
                        permission: ResourceName.CARD_IMPLEMENTATIONS,
                    } as MenuItem,
                    {
                        titleKey: "menu.posMappings",
                        route: routes.posMappings,
                        to: routes.posMappings.fillPathParams(),
                        permission: ResourceName.POS_MAPPINGS,
                    } as MenuItem,
                    {
                        titleKey: "menu.posTypes",
                        route: routes.posTypes,
                        to: routes.posTypes.fillPathParams(),
                        permission: ResourceName.POS_TYPES,
                    } as MenuItem,
                    {
                        titleKey: "menu.emvGlobalConfiguration",
                        route: routes.emvGlobalConfigurations,
                        to: routes.emvGlobalConfigurations.fillPathParams(),
                        permission: ResourceName.EMV_GLOBAL_CONFIGURATIONS,
                    } as MenuItem,
                    {
                        titleKey: "menu.emvKernelProfiles",
                        route: routes.emvKernelProfiles,
                        to: routes.emvKernelProfiles.fillPathParams(),
                        permission: ResourceName.EMV_KERNEL_PROFILES,
                    } as MenuItem,
                    {
                        titleKey: "menu.allowedProductsProfiles",
                        route: routes.allowedProductsProfiles,
                        to: routes.allowedProductsProfiles.fillPathParams(),
                        permission: ResourceName.ALLOWED_PRODUCT_PROFILES,
                    } as MenuItem,
                    // {
                    //     titleKey: "menu.mrnImportConfig",
                    //     route: routes.mrnImportConfig,
                    //     to: routes.mrnImportConfig.fillPathParams(),
                    // } as MenuItem,
                    {
                        titleKey: "menu.loyaltyAllowedMatrix",
                        route: routes.loyaltyAllowedMatrix,
                        to: routes.loyaltyAllowedMatrix.fillPathParams(),
                        permission: ResourceName.LOYALTY_ALLOWED_MATRIX,
                    } as MenuItem,
                    {
                        titleKey: "menu.loyaltyMessages",
                        route: routes.loyaltyMessages,
                        to: routes.loyaltyMessages.fillPathParams(),
                        permission: ResourceName.LOYALTY_MESSAGES,
                    } as MenuItem,
                    {
                        titleKey: "menu.hostResponseCodes",
                        route: routes.hostResponseCodes,
                        to: routes.hostResponseCodes.fillPathParams(),
                        permission: ResourceName.HOST_RESPONSE_CODE,
                    } as MenuItem,
                    {
                        titleKey: "menu.printingProfiles",
                        route: routes.printingProfiles,
                        to: routes.printingProfiles.fillPathParams(),
                        permission: ResourceName.PRINTING_PROFILES,
                    } as MenuItem,
                    {
                        titleKey: "menu.dccProfiles",
                        route: routes.dccProfiles,
                        to: routes.dccProfiles.fillPathParams(),
                        permission: ResourceName.DCC_PROFILES,
                    } as MenuItem,
                    {
                        titleKey: "menu.complTrxImport",
                        route: routes.complxTrxImport,
                        to: routes.complxTrxImport.fillPathParams(),
                        permission: ResourceName.COMPL_TRX_IMPORT,
                    } as MenuItem,
                    // {
                    //     titleKey: "menu.dummyProductItems",
                    //     route: routes.dummyProductItems,
                    //     to: routes.dummyProductItems.fillPathParams(),
                    // } as MenuItem,
                    {
                        titleKey: "menu.manualDasConfigurations",
                        route: routes.manualDasConfigurations,
                        to: routes.manualDasConfigurations.fillPathParams(),
                        permission: ResourceName.MANUAL_DAS_CONFIGURATION,
                    } as MenuItem,
                ],
            } as SubMenuItem,
            {
                key: "menu_campaign_management",
                icon: CustomIconCodes.Flag,
                title: "menu.campaignManagement",
                menuItems: [
                    {
                        titleKey: "menu.terminalVersions",
                        route: routes.terminalVersion,
                        to: routes.terminalVersion.fillPathParams(),
                        permission: ResourceName.TERMINAL_VERSIONS,
                    } as MenuItem,
                    {
                        titleKey: "menu.periodicCampaign",
                        route: routes.periodicCampaign,
                        to: routes.periodicCampaign.fillPathParams(),
                        permission: ResourceName.PERIODIC_CAMPAIGN,
                    } as MenuItem,
                    {
                        titleKey: "menu.campaigns",
                        route: routes.campaigns,
                        to: routes.campaigns.fillPathParams(),
                        permission: ResourceName.CAMPAIGNS,
                    } as MenuItem,
                    {
                        titleKey: "menu.alerts",
                        route: routes.alerts,
                        to: routes.alerts.fillPathParams(),
                        permission: ResourceName.ALERTS,
                    } as MenuItem,
                ],
            } as SubMenuItem,
            {
                key: "submenu_systemConfiguration",
                icon: CustomIconCodes.Dots,
                title: "menu.systemConfiguration",
                menuItems: [
                    {
                        titleKey: "menu.dataGroups",
                        route: routes.dataGroups,
                        to: routes.dataGroups.fillPathParams(),
                        permission: ResourceName.DATA_GROUPS,
                    } as MenuItem,
                    {
                        titleKey: "menu.dynamicProperties",
                        route: routes.dynamicProperties,
                        to: routes.dynamicProperties.fillPathParams(),
                        permission: ResourceName.DYNAMIC_PROPERTIES,
                    } as MenuItem,
                    {
                        titleKey: "menu.dynamicPropertyGroups",
                        route: routes.dynamicPropertyGroups,
                        to: routes.dynamicPropertyGroups.fillPathParams(),
                        permission: ResourceName.DYNAMIC_PROPERTY_GROUPS,
                    } as MenuItem,
                    {
                        titleKey: "menu.appConfigs",
                        route: routes.applicationConfigurations,
                        to: routes.applicationConfigurations.fillPathParams(),
                        permission: ResourceName.APP_CONFIGURATIONS,
                    } as MenuItem,
                    {
                        titleKey: "menu.configurationTransfer",
                        route: routes.configurationTransfer,
                        to: routes.configurationTransfer.fillPathParams(),
                        permission: ResourceName.CONFIGURATION_TRANSFER,
                    } as MenuItem,
                ],
            } as SubMenuItem,
            {
                key: "menu_system",
                icon: CustomIconCodes.Flag,
                title: "menu.system",
                menuItems: [
                    {
                        titleKey: "menu.userLogs",
                        route: routes.userLogs,
                        to: routes.userLogs.fillPathParams(),
                        permission: ResourceName.USER_LOGS,
                    } as MenuItem,
                ],
            } as SubMenuItem,
        ],
    } as MenuItemGroup,

    // {
    //     key: "menu_campaign_management",
    //     title: "menu.campaignManagement",
    //     unclassifiedItems: [
    //         {
    //             titleKey: "menu.terminalVersions",
    //             route: routes.terminalVersions,
    //             to: routes.terminalVersions.fillPathParams(),
    //             menuIcon: IconCodes.FieldNumberOutlined,
    //         } as MenuIconItem,
    //     ],
    // } as MenuItemGroup,
    // {
    //     key: "menu_system",
    //     title: "menu.system",
    //     unclassifiedItems: [
    //         {
    //             titleKey: "menu.userLogs",
    //             route: routes.userLogs,
    //             to: routes.userLogs.fillPathParams(),
    //             menuIcon: IconCodes.AreaChartOutlined,
    //         } as MenuIconItem,
    //     ],
    // } as MenuItemGroup,
];
